<template>
  <div>
    <!-- <page-header :userImage="wxUserInfo.headPhoto" :userName="wxUserInfo.nickName"></page-header> -->
    <div style="background: #fff;padding-bottom: 1rem">
      <group
        label-width="7em"
        label-margin-right="2em"
        label-align="justify"
        gutter="0"
      >
        <div id="identity">
          <p>选择身份</p>
          <ul>
            <li
              v-for="(item, index) in identData"
              @click="identChange(item, index)"
              :class="[index + 1 == identValue[0] ? 'active_ident' : '']"
              :key="index"
            >
              <img :src="item.picUrl" />
            </li>
          </ul>
        </div>

        <x-address
          title="address"
          @on-hide="addressChange"
          v-model="addressValue"
          raw-value
          :list="addressData"
          value-text-align="right"
          label-align="justify"
        >
          <label
            slot="title"
            class="weui-label vux-cell-justify"
            style="width: 1rem; text-align: justify; "
          >
            <span class="inputTit">地区</span>
          </label>
        </x-address>

        <cell
          :value="hospitalObj.fullName"
          is-link
          value-align="right"
          @click.native="showHospital"
          v-show="
            identValue[0] == 1 || identValue[0] == 2 || identValue[0] == 3
          "
        >
          <label
            slot="icon"
            class="weui-label vux-cell-justify"
            style="width: 1rem; text-align: justify; "
          >
            <span class="inputTit">医院</span>
          </label>
        </cell>

        <x-input
          class="weui-vcode"
          :required="true"
          v-model.trim="companyName"
          type="text"
          text-align="right"
          v-show="identValue[0] == 4 || identValue[0] == 5"
        >
          <label
            slot="label"
            class="weui-label vux-cell-justify"
            style="width: 2rem; text-align: justify; "
          >
            <span class="inputTit">学校/机构</span>
          </label>
        </x-input>

        <popup-picker
          title="科室:"
          :data="departmentData"
          :columns="1"
          v-model="departmentValue"
          ref="department"
          @on-change="departmentChange"
          show-name
          v-show="identValue[0] == 1"
        >
          <label
            slot="title"
            class="weui-label vux-cell-justify"
            style="width: 1rem; text-align: justify; "
          >
            <span class="inputTit">科室</span>
          </label>
        </popup-picker>
        <!--<span>{{$refs.department.getNameValues()}}</span>-->
        <popup-picker
          show-name
          title="职称:"
          :data="dutyData"
          :columns="3"
          v-model="dutyValue"
          ref="duty"
          v-show="
            identValue[0] == 1 || identValue[0] == 2 || identValue[0] == 3
          "
        >
          <label
            slot="title"
            class="weui-label vux-cell-justify"
            style="width: 1rem; text-align: justify; "
          >
            <span class="inputTit">职称</span>
          </label>
        </popup-picker>

        <x-input
          class="weui-vcode"
          :required="true"
          v-model.trim="duties"
          type="text"
          text-align="right"
          v-show="identValue[0] == 4 || identValue[0] == 5"
        >
          <label
            slot="label"
            class="weui-label vux-cell-justify"
            style="width: 2rem; text-align: justify; "
          >
            <span class="inputTit">专业/职务</span>
          </label>
        </x-input>
      </group>
      <x-button class="submit" @click.native="submitBt" :disabled="canSubmit">
        确认
      </x-button>
    </div>
    <my-hospital
      :address="addressValue"
      @save-hospital="saveHospital"
      :showAddressPicker="showHospitalPicker"
    ></my-hospital>
  </div>
</template>
<script>
import index from './default';
export default index;
</script>
<style lang="less" scoped>
@import 'style.less';
#identity {
  margin-top: 0.267rem;
  padding: 10px 15px;
  p {
    font-size: 0.4rem;
    color: rgb(102, 102, 102);
    margin-bottom: 0.4rem;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 2.8rem;
      height: 2rem;
      background: #ffffff;
      border: 1px solid #d8d8d8;
      border-radius: 0.0749rem;
      margin-bottom: 0.4rem;
      img {
        width: 100%;
        height: 100%;
        display: block;
        margin: auto;
        margin-bottom: 0.4rem;
      }
      span {
        width: 100%;
        display: block;
        text-align: center;
        color: #027cfa;
        font-size: 0.4rem;
        margin-top: -0.15rem;
      }
    }
    li:nth-child(2),
    li:nth-child(5) {
      margin-left: 0.4rem;
      margin-right: 0.4rem;
    }
    .active_ident {
      background: #e5f1fe !important;
      border: 1px solid #027cfa !important;
    }
  }
}
.alt {
  padding-top: 0.33rem;
  padding-bottom: 0.4rem;
  text-align: center;
  background: #fff;
  margin-bottom: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  * {
    font-size: 0.24rem;
  }
  span:nth-of-type(1) {
    font-size: 0.4rem;
    color: rgb(102, 102, 102);
    margin-right: 0.2rem;
  }
}
.inputTit {
  font-size: 0.4rem;
  color: rgb(102, 102, 102);
}
.icon,
.icon-pintu {
  margin-right: 0.35rem;
  color: #01c2e0;
}
.sendCode {
  width: 2.37rem;
  height: 0.65rem;
  color: #01c2e0;
  padding: 0 0.1rem;
  &:after {
    border-color: #01c2e0;
    border-radius: 0.7rem;
  }
}
.submit {
  color: #fff;
  padding: 0.24rem 0.1rem;
  width: 95%;
  margin-top: 2rem;
  background: #027cfa;
  // &:after {
  //   border-color: #01C2E0;
  //   border-radius: 0;
  // }
}
</style>
